import user from './user';

export default {
  user,
}


// WEBPACK FOOTER //
// ./src/actions/index.js